/*
Luke Harby
slackwise LTD
https://slackwise.org.uk
2012 - present
*/

import { HIDDEN_CLASS } from './global';

/* toggleVisibility function */
const toggleVisibility = (elem) => {
    [...elem].forEach(item => {
        item.classList.contains(HIDDEN_CLASS)
            ? item.classList.remove(HIDDEN_CLASS)
            : item.classList.add(HIDDEN_CLASS)
    });
}

export { toggleVisibility };